import {AvatarStack} from '@primer/react'
import {GitHubAvatar} from '@github-ui/github-avatar'

interface Author {
  avatarUrl: string
  login: string
}
export interface CommentPreviews {
  author?: Author | null
}
export function PreviewAuthors({commentAuthors}: {commentAuthors: Author[]}) {
  if (commentAuthors.length < 1) return null

  return (
    <AvatarStack>
      {commentAuthors.map(({login, avatarUrl}) => (
        <GitHubAvatar key={login} alt={login} size={18} src={avatarUrl} />
      ))}
    </AvatarStack>
  )
}
